(() => {
  const setup = (root) => {
    root.querySelectorAll('.pitb-guide-article').forEach((article) => {
      const toc = article.querySelector('[data-guide-toc]');
      const content = article.querySelector('.article__content');
      if (!toc || !content || toc.dataset.ready) return;
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length < 3) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `guide-section-${article.closest('[id]')?.id || 'article'}-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.dataset.ready = 'true';
      toc.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', () => setup(document));
})();
